// extracted by mini-css-extract-plugin
var _1 = "D1dk_gWHyHrgkcRk4u_A";
var _2 = "jcd_MKivonleTDFVN5cC";
var _3 = "ZTdWex4IZNocMofNRnMS";
var _4 = "gWTyjwqU1AfBdPkHFxkP";
export { _1 as "embeddedFrame", _2 as "embeddedFrameBlock", _3 as "embeddedFrameHeading", _4 as "embeddedFrameText" }
